import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {Router} from '@angular/router';

@Injectable()
export class WorkingObjectsResolver extends BaseResolverService {
    protected redirectUrl = '/';

    constructor(
        service: WorkingObjectsApiService,
        router: Router,
    ) {
        super(service, router);
    }

    processNullData() {
        return null;
    }

    processError() {
        return null;
    }
}
